import { AppError } from "./index";

/**
 * Custom error to encapsulate HTTP not found error.
 */
export class NotFoundError extends AppError {}
